import { render, staticRenderFns } from "./downloadCenter.vue?vue&type=template&id=84267746&"
import script from "./downloadCenter.vue?vue&type=script&lang=js&"
export * from "./downloadCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports